export default {
  title: 'Reducere contract anual',
  buttons: {
    edit: 'Editează reducerea',
    save: 'Salvează reducerea',
  },
  toasts: {
    invalid_discount: 'Reducerea pentru contractul anual trebuie să fie între {{min}}% și {{max}}%',
  },
};
